import React, { useContext, useEffect, useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { MyContext } from "../../MyContextApi";

function ReportDateTimeRange({
  onFromDateTimeChange,
  onToDateTimeChange,
  reportfromDateTime,
  setreportFromDateTime,
  reporttoDateTime,
  setreportToDateTime,
}) {
  // const { fromDateTime, setFromDateTime, toDateTime, setToDateTime } = useContext(MyContext);

  // // Check if fromDateTime or toDateTime are null, then set the default value
  // useEffect(() => {
  //   if (!reportfromDateTime || !reporttoDateTime) {
  //     const today = dayjs();
  //     const defaultFromDateTime = today.subtract(6, "day").startOf("day"); // 12:00 AM 6 days ago
  //     const defaultToDateTime = today.hour(23).minute(55); // 11:55 PM

  //     if (!reportfromDateTime) {
  //       setreportFromDateTime(defaultFromDateTime);
  //       onFromDateTimeChange(defaultFromDateTime);
  //     }

  //     if (!reporttoDateTime) {
  //       setreportToDateTime(defaultToDateTime);
  //       onToDateTimeChange(defaultToDateTime);
  //     }
  //   }
  // }, [
  //   reportfromDateTime,
  //   reporttoDateTime,
  //   setreportFromDateTime,
  //   setreportToDateTime,
  //   onFromDateTimeChange,
  //   onToDateTimeChange,
  // ]);

  const handleFromDateTime = (newDateTime) => {
    const formattedFromDateTime = dayjs(newDateTime).format(
      "DD-MM-YYYY HH:mm:ss"
    );
    //
    setreportFromDateTime(newDateTime);
    onFromDateTimeChange(newDateTime);
  };

  const handleToDateTime = (newDateTime) => {
    const formattedToDateTime = dayjs(newDateTime).format(
      "DD-MM-YYYY HH:mm:ss"
    );
    //
    setreportToDateTime(newDateTime);
    onToDateTimeChange(newDateTime);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div
        style={{
          display: "flex",
          gap: "1vh",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker
            label="From"
            value={reportfromDateTime} // No default value
            onChange={handleFromDateTime}
            format="DD-MM-YYYY HH:mm"
            // maxDateTime={dayjs()} // Disable future dates
            sx={{
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
              padding: "8px",
              minWidth: "unset",
              width: "auto",
            }}
            slotProps={{ textField: { placeholder: "Select Date & Time" } }} // Add placeholder
          />
        </DemoContainer>
        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker
            label="To"
            value={reporttoDateTime} // No default value
            onChange={handleToDateTime}
            format="DD-MM-YYYY HH:mm"
            // maxDateTime={dayjs()} // Disable future dates
            sx={{
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
              padding: "8px",
              minWidth: "unset",
              width: "auto",
            }}
            slotProps={{ textField: { placeholder: "Select Date & Time" } }} // Add placeholder
          />
        </DemoContainer>
      </div>
    </LocalizationProvider>
  );
}

export default ReportDateTimeRange;
